/**
 * @file 展示一些风险提示的tip
 */
import { Modal, Button } from '@bfe/moly';
import { useFm } from '@web3/base-hooks';
import { useWallet } from '@/hooks/wallet';

import styles from './index.module.scss';

interface Props {
  show: boolean;
  onClose: () => void;
}

export const ChangeWalletModal = (props: Props) => {
  const { show, onClose } = props;
  const fm = useFm();
  const { openLoginModal } = useWallet();

  return (
    <Modal
      open={show}
      onClose={onClose}
      title={fm('stakingNotice')}
      width={480}
      footer={null}
      modal={false}
      overlayClassName={styles.overlay}
    >
      <div className={styles.content}>{fm('currentWalletDoesNotSupport')}</div>
      <Button
        variant="primary"
        className={styles.button}
        onClick={() => {
          openLoginModal();
          onClose();
        }}
      >
        {fm('switchWallet')}
      </Button>
    </Modal>
  );
};
